export default "__VITE_ASSET__BOhGkveT__"